import { render, staticRenderFns } from "./DxHarvestByVarieties.vue?vue&type=template&id=4fd084e2&"
import script from "./DxHarvestByVarieties.vue?vue&type=script&lang=js&"
export * from "./DxHarvestByVarieties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports